var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 40a20 20 0 1 0 -20-20 19.952 19.952 0 0 0 20 20z",
    fill: "#2775ca"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m727.837 521.33c0-2.917-1.75-3.917-5.25-4.333-2.5-.333-3-1-3-2.167s.833-1.917 2.5-1.917c1.5 0 2.333.5 2.75 1.75a.627.627 0 0 0 .583.417h1.333a.57.57 0 0 0 .583-.583v-.083a4.163 4.163 0 0 0 -3.75-3.417v-2c0-.333-.25-.583-.667-.667h-1.25c-.333 0-.583.25-.667.667v1.917c-2.5.333-4.083 2-4.083 4.083 0 2.75 1.667 3.833 5.167 4.25 2.333.417 3.083.917 3.083 2.25s-1.167 2.25-2.75 2.25c-2.167 0-2.917-.917-3.167-2.167a.609.609 0 0 0 -.583-.5h-1.417a.57.57 0 0 0 -.583.583v.083c.333 2.083 1.667 3.583 4.417 4v2c0 .333.25.583.667.667h1.247c.333 0 .583-.25.667-.667v-2c2.5-.417 4.167-2.167 4.167-4.417z",
    transform: "translate(-702.337 -498.163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.756 317.753a12.47 12.47 0 0 1 0-23.417.837.837 0 0 0 .5-.833v-1.167a.633.633 0 0 0 -.5-.667.5.5 0 0 0 -.333.083 15 15 0 0 0 0 28.583.507.507 0 0 0 .75-.333c.083-.083.083-.167.083-.333v-1.169a1.11 1.11 0 0 0 -.5-.747zm8.833-26a.507.507 0 0 0 -.75.333c-.083.083-.083.167-.083.333v1.167a1.105 1.105 0 0 0 .5.833 12.47 12.47 0 0 1 0 23.417.837.837 0 0 0 -.5.833v1.167a.633.633 0 0 0 .5.667.5.5 0 0 0 .333-.083 15.06 15.06 0 0 0 0-28.667z",
    transform: "translate(-243.006 -285.837)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/usdc.27f415ba778073d06acad7e958eaa641.svg";
export { ForwardRef as ReactComponent };